import Vue from 'vue'
import { bestConfigurationsQuery } from './queries/best-configurations'
import { initialFiltersQuery } from './queries/initial-filters'
import { regionFiltersQuery } from './queries/region-filters'
import { bestSpecialSaleConfigurationsQuery } from './queries/best-special-sale-configurations'
import { coveredPeriod } from './queries/covered-period'
import type SessionIdStorageInterface from '../service/session-id-storage-interface'
import { productDetailFiltersAndConfigurationsQuery } from './queries/product-detail-filters-and-configurations'
import type {FilterEntitySet} from '../types/filter-entity-set'
import {filtersQuery} from './queries/filters'
import type ProductsApiClientInterface from './products-api-client-interface'

class ProductsApiClient implements ProductsApiClientInterface {
  baseUrl: string
  sessionIdStorage: SessionIdStorageInterface

  constructor (baseUrl, sessionIdStorage: SessionIdStorageInterface) {
    this.baseUrl = baseUrl
    this.sessionIdStorage = sessionIdStorage
  }

  async doQuery (query: string, variables: {[string]: mixed}): mixed {
    try {
      const headers = {'X-SID': this.sessionIdStorage.getSessionId()}
      const response = await Vue.$http['post'](
        this.baseUrl,
        {query, variables},
        {withCredentials: true, headers}
      )

      return response.data
    } catch (e) {
      if (e && e.data) {
        throw e.data
      }

      throw new Error('An unexpected exception has occurred')
    }
  }

  async getInitialFilters (variables): Promise<mixed> {
    return this.doQuery(initialFiltersQuery, variables)
  }

  async getFilters (criteria): Promise<FilterEntitySet> {
    let response = await this.doQuery(filtersQuery, {criteria})
    return response.data.filters
  }

  async getRegionFilters (variables): Promise<mixed> {
    return this.doQuery(regionFiltersQuery, variables)
  }

  async getBestProductConfigurations (criteria: mixed, bestOnePer, bestRule = 'cheapest'): Promise<mixed> {
    return this.doQuery(bestConfigurationsQuery, {criteria, bestOnePer, bestRule})
  }

  async getCoveredPeriod (criteria: mixed): Promise<mixed> {
    return this.doQuery(coveredPeriod, {criteria: criteria})
  }

  async getProductDetailFiltersAndConfigurations (productType, filterCriteria, configurationCriteria): Promise<mixed> {
    return this.doQuery(
      productDetailFiltersAndConfigurationsQuery,
      {
        filterCriteria: filterCriteria,
        configurationCriteria: configurationCriteria
      }
    )
  }

  getBestSpecialSaleConfigurations () {
    const salesChannelId = Vue.prototype.$container.config.productApiSalesChannelSpecialId
    return this.doQuery(bestSpecialSaleConfigurationsQuery, {salesChannelId})
  }
}

export default ProductsApiClient



// WEBPACK FOOTER //
// ./src/products-api/products-api-client.js